import i18n from "@/i18n";

export const COUNTRY_LANGUAGE_CONFIG = {
  BJ: { fr: "frToEn", en: "enToFr", default: "fr" },
  BF: { en: "enToFr", fr: "frToEn", default: "fr" },
  CM: { en: "enToFr", fr: "frToEn", default: "en" },
  RW: { en: "enToFr", fr: "frToEn", default: "en" },
  TH: { th: "thToEn", en: "enToTh", default: "th" },
  ET: { am: "amToEn", en: "enToAm", default: "am" },
  TD: { fr: "frToAr", ar: "arToFr", default: "fr" },
  ML: { fr: "frToEn", en: "enToFr", default: "fr" },
  NE: { fr: "frToEn", en: "enToFr", default: "fr" },
  MZ: { pt: "ptToEn", en: "enToPt", default: "pt" },
  EG: { en: "enToAr", ar: "arToEn", default: "ar" },
  TZ: { sw: "swToEn", en: "enToSw", default: "sw" },
  default: { en: "enToFr", fr: "frToEn", default: "fr" },
};

const FIXED_LANGUAGE_COUNTRIES = {
  GH: "en",
  UG: "en",
  ZM: "en",
  KE: "en",
  ID: "en",
  SL: "en",
  SN: "fr",
  CI: "fr",
};

const LANGUAGE_LABELS = {
  am: "AM",
  ar: "AR",
  en: "EN",
  fr: "FR",
  pt: "PT",
  sw: "SW",
  th: "TH",
};

export function getCountryLanguageConfig(countryCode) {
  return COUNTRY_LANGUAGE_CONFIG[countryCode] || COUNTRY_LANGUAGE_CONFIG.default;
}

export function isCountryLanguageSwitchEnabled(countryCode) {
  return Object.prototype.hasOwnProperty.call(COUNTRY_LANGUAGE_CONFIG, countryCode);
}

export function getSupportedCountryLanguages(countryCode) {
  const config = getCountryLanguageConfig(countryCode);
  return Object.keys(config).filter((key) => key !== "default");
}

export function getDefaultLanguageByCountry(countryCode) {
  if (FIXED_LANGUAGE_COUNTRIES[countryCode]) {
    return FIXED_LANGUAGE_COUNTRIES[countryCode];
  }
  const config = getCountryLanguageConfig(countryCode);
  const supportedLanguages = getSupportedCountryLanguages(countryCode);
  return config.default || supportedLanguages[0] || "en";
}

export function setI18nLanguage(lang, vm) {
  i18n.locale = lang || "en";
  localStorage.setItem("lang", i18n.locale);
  if (vm && typeof vm.$forceUpdate === "function") {
    vm.$forceUpdate();
  }
  return i18n.locale;
}

export function setLanguageByCountry(countryCode, vm) {
  return setI18nLanguage(getDefaultLanguageByCountry(countryCode), vm);
}

export function getNextLanguage(currentLang, supportedLanguages) {
  if (!supportedLanguages.length) {
    return "";
  }
  const currentIndex = supportedLanguages.indexOf(currentLang);
  return supportedLanguages[(currentIndex + 1) % supportedLanguages.length];
}

export function getLanguageLabel(lang) {
  return LANGUAGE_LABELS[lang] || String(lang || "").toUpperCase();
}
